<div id="popup-addcar-container" *ngIf="!diviceXs && !diviceSm">

    <h2>
        <span class="material-icons">sentiment_satisfied_alt</span> Producto agregado al carrito
    </h2>

    <div id="addedProduct" fxLayout="row" fxLayoutAlign="space-around center">
        <div id="img">
            <img *ngIf="data.product.mainPhoto !== undefined" src="{{data.product.mainPhoto}}" [alt]="data.product.name">
            <img *ngIf="data.product.mainPhoto === undefined" src="../../../../assets/img/caja.jpg" [alt]="data.product.name">
        </div>

        <div id="content">
            <h3>{{data.product.name}}</h3>
            <div id="costs" fxLayout="row" fxLayoutAlign="space-around center">
                <p><strong>Precio (Und.)</strong><br /> $ {{data.product.price | currency:'COP '}}</p>
                <p><strong>Gessis.</strong><br /> {{data.product.points | number}}</p>
                <p><strong>Cant.</strong><br /> {{data.quanty}}</p>
            </div>
        </div>
    </div>

    <div id="endContent" fxLayout="row" fxLayoutAlign="space-around center">
        <h4 id="subTotal">Sub-total, ({{data.product.quantity}}) item(s): $ {{totalByProduct | currency:'COP '}}</h4>

        <a id="linkRegister" (click)="CloseDialog()">Seguir Comprando</a>

        <button [routerLink]="['/shopping-cart']" (click)="CloseDialog()">Ver carrito</button>
    </div>

</div>

<div id="popup-addcar-container" *ngIf="diviceXs || diviceSm">

    <h2>
        <span class="material-icons">sentiment_satisfied_alt</span> Producto agregado al carrito
    </h2>

    <div id="addedProductCell">
        <h3>{{data.product.name}}</h3>

        <div id="contentProductCell" fxLayout="row" fxLayoutAlign="space-around center">

            <div id="img">
                <img *ngIf="data.product.mainPhoto !== undefined" src="{{data.product.mainPhoto}}" [alt]="data.product.name">
                <img *ngIf="data.product.mainPhoto === undefined" src="../../../../assets/img/caja.jpg" [alt]="data.product.name">
            </div>

            <div id="costs">
                <p><strong>Precio (Und.)</strong><br /> $ {{data.product.price | currency:'COP '}}</p>
                <p><strong>Gessis.</strong><br /> {{data.product.points | number}}</p>
                <p><strong>Cant.</strong><br /> {{data.quanty}}</p>
            </div>
        </div>

        <h4 id="subTotal">Sub-total, ({{data.product.quantity}}) item(s): $ {{totalByProduct | currency:'COP '}}</h4>

        <div id="endContent" fxLayout="row" fxLayoutAlign="space-around center">

            <a id="linkRegister" (click)="CloseDialog()">Seguir Comprando</a>

            <button [routerLink]="[{ outlets: { primary: ['shopping-cart'], sidebar: ['shopping-cart']}}]" (click)="CloseDialog()">Ver carrito !</button>
        </div>
    </div>

</div>